import { type ImageCardData, CardDataType, type CardData, ComponentName} from "../types";
import { Credit } from "@ca.vmedia.tv/domains";

export class CreditCardData implements CardData, ImageCardData {

    private credit: Credit;

    constructor(credit: Credit) {
        this.credit = credit;
    }

    getId(): string {
        return Credit.getId(this.credit);
    }

    getImage(): string {
        return this.credit.image ?? '';
    }

    getPersonId(): number | null {
        return this.credit.person?.id ?? null;
    }

    getClass(): string {
        return 'credit-card';
    }

    getType(): number {
        return CardDataType.Credit;
    }

    getName(): string {
        return this.credit.person?.name ?? "";
    }

    getDescription(): string {
        const charName = this.credit.characterName;
        const roleName = this.credit.role?.name;
        if (charName) {
            if (roleName) {
                return `${charName} / ${roleName}`;
            }
            return charName;
        }
        return roleName ?? "";
    }

    getComponentName(): ComponentName {
        return ComponentName.CREDIT;
    }

    getCreditItem(): Credit {
        return this.credit;
    }
}
